import { render, staticRenderFns } from "./InputPlace.vue?vue&type=template&id=5e56bfea&scoped=true&"
import script from "./InputPlace.vue?vue&type=script&lang=js&"
export * from "./InputPlace.vue?vue&type=script&lang=js&"
import style0 from "./InputPlace.vue?vue&type=style&index=0&id=5e56bfea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56bfea",
  null
  
)

export default component.exports